<template>
    <footer>
        <div class="gtco-container" style="padding-bottom: 30px;font-size: 14px;">
            <div style="background-color: rgba(6, 79, 53, 1);margin: 30px 0;height: 1px;width: 100%;"></div>
            <div class="row wow fadeInUp"  data-wow-delay="0s" data-wow-duration="1000ms">
                <div class="col-md-10 col-sm-12">
                    <div style="display: flex;align-items: center;">
                        <div style="margin-right: 20px;"><img src="/static/img/home/bottom-tag.png" style="width: 125px;"/></div>
                        <div style="line-height: 30px;padding: 10px 0;">
                            <div>©2024 无名碳链企业服务平台 香港無名碳鏈技術有限公司 版权所有 All Rights Reserved</div>
<!--                            <div>网站备案号：粤ICP备xxxxxxx号</div>-->
                        </div>
                    </div>
                </div>
                <div class="col-md-2 col-sm-12" style="text-align: right;">
                    <div style="text-align: center;">
                        <img src="/static/img/home/qr-code.jpg" style="width: 80px;"/>
                        <div style="font-size: 12px;">商务合作</div>
                    </div>

                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
  name: "GlobalFooter",
  data () {
    return {
        activeMenu:[
            {index:0,name:'index',navName:'首页',checked:false},
            {index:1,name:'software',navName:'仿真软件',checked:false},
            {index:2,name:'service',navName:'服务',checked:false},
            {index:3,name:'blog',navName:'博客',checked:false},
            {index:4,name:'aboutUs',navName:'关于我们',checked:false},
        ]
    };
  },
    mounted () {
        // window.addEventListener("scroll", this.scrollToTop, true);
        console.log("this.$router",this.$route)
        this.activeMenu.forEach(e=>{
            if (e.name == this.$route.name){
                e['checked'] = true
            }else{
                e['checked'] = false
            }
        })
        this.$nextTick(()=>{
            new this.$wow.WOW().init()
        })
        console.log("this.activeMenu",this.activeMenu)
    },
};
</script>

<style lang="less" scoped>
  .footer{
    background-color: rgba(45, 43, 64, 1);
  }
.comment-footer{
    font-size: 40px;
}
</style>
